import { apiClient } from './apiClient';

export interface VerticalPack {
  slug: string;
  name: string;
  description: string;
  version: number;
  enabled_signal_keys: string[];
  min_score_threshold: number;
}

export interface TenantVerticalAssignment {
  pack: VerticalPack;
  applied_version: number;
  applied_at: string;
}

export interface VerticalPackApplyResult {
  pack_slug: string;
  pack_version: number;
  lead_suggestion_settings: { updated: string[]; skipped: string[] };
  email_templates: { created: number; skipped: number };
  chatbot_config: { updated: string[]; skipped: string[] };
  assignment_created: boolean;
  prior_pack_templates_preserved: boolean;
  message: string;
}

export interface ResolvedVerticalConfig {
  is_generic: boolean;
  pack_slug: string | null;
  pack_version: number | null;
  business_type_key: string;
  taxonomy: {
    business_types: Array<{ key: string; label: string; vertical_slug: string | null }>;
    business_type_relevance: Record<string, { services_offered: string[]; ideal_customer_types: string[] }>;
    services_offered: string[];
    ideal_customer_types: string[];
    target_company_sizes: string[];
  };
  surfaced_first: {
    services_offered: string[];
    ideal_customer_types: string[];
  };
  preselected: {
    services_offered: string[];
    ideal_customer_types: string[];
  };
  defaults: {
    radius_miles: number;
    target_company_sizes: string[];
  };
  discovery_subjects?: string[];
  apollo_titles?: string[];
  scoring_weights: Record<string, number>;
  enabled_signal_keys: string[];
}

export const verticalPackService = {
  async listVerticalPacks(): Promise<VerticalPack[]> {
    return apiClient.get('/verticals/');
  },

  async getCurrentVerticalPack(): Promise<TenantVerticalAssignment | null> {
    return apiClient.get('/verticals/current/');
  },

  async resolveVerticalConfig(): Promise<ResolvedVerticalConfig> {
    return apiClient.get('/verticals/resolved/');
  },

  async applyVerticalPack(slug: string, overwriteUnedited = false): Promise<VerticalPackApplyResult> {
    return apiClient.post('/verticals/apply/', { slug, overwrite_unedited: overwriteUnedited });
  },
};
